import { idParam, ROLES } from "../../../../../helpers/commons.helpers";

/**
 * Tools route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ToolRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
  {
    path: "/tools/destinations",
    name: "Destinations",
    meta: {
      modules: ["destinations"],
      requiresAuth: true,
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
    },
    component: () =>
      import(
        /* webpackChunkName: "DestinationsManager" */ "@/modules/tools/modules/destinations/pages/Destinations"
      )
  },
  {
    path: "/tools/destinations/new",
    name: "New Destination",
    meta: {
      modules: ["destinations"],
      requiresAuth: true,
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
    },
    component: () =>
      import(
        /* webpackChunkName: "NewDestination" */ "@/modules/tools/modules/destinations/pages/NewDestination"
      )
  },
  {
    path: "/tools/destinations/:id",
    name: "Destination Details",
    meta: {
      modules: ["destinations"],
      requiresAuth: true,
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
    },
    component: () =>
      import(
        /* webpackChunkName: "DestinationDetails" */ "@/modules/tools/modules/destinations/pages/DestinationDetails"
      )
  }
];
